import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import PropTypes from "prop-types";
import { SelectInput } from "../../../common/form";
import { MessageBox } from "../../../common";
const formName = "exportsForm";
class ExportsForm extends Component {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    return (
      <div>
      {this.props.showTransitionWarning && (
            <MessageBox key="clientNumberWarning" className="transition-alert">
            <span className="d-flex">
              <FormattedMessage id="importExport.importMembers.form.warnings.clientInTransition" />
            <button
                className="refresh-transition"
                onClick={() => this.props.refetchIsTransition()}
              >
            <span className="icon icon-loop" />
            </button>
              </span>
            </MessageBox>
      )}
        <Field
          id="exportType"
          name="exportType"
          component={SelectInput}
          options={this.props.options}
          addBlankOption={true}
          label={
            <FormattedMessage id="importExport.exports.form.exportationType" />
          }
      />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector("exportMembersForm");

  return {
    clientId: Number.parseInt(selector(state, "clientId")),
    fileFormat: selector(state, "fileFormat"),
    authLanguageCode: state.auth.user.languageCode,
  };
}

ExportsForm.propTypes = {
  options: PropTypes.array,
  showInTransitionMessage: PropTypes.bool,
  showTransitionWarning: PropTypes.bool,
  refetchIsTransition: PropTypes.func
};
ExportsForm = reduxForm({
  form: formName,
})(ExportsForm);

export default connect(mapStateToProps, null, null, { withRef: true })(ExportsForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exports/ExportsForm.js